"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getForbiddenUrl = getForbiddenUrl;
exports.getIsAuthorizedArray = getIsAuthorizedArray;
exports.getRedirectLocation = getRedirectLocation;
exports.getResponseHeaders = getResponseHeaders;
exports.getRouteCspOptions = getRouteCspOptions;
exports.getServerErrorUrl = getServerErrorUrl;
exports.getStatus = getStatus;
exports.isAnonymous = isAnonymous;
exports.isFloorplansDisabled = isFloorplansDisabled;
exports.isForcedSignOut = isForcedSignOut;
var _find2 = _interopRequireDefault(require("lodash/find"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _reactRouter = require("react-router");
var _config = _interopRequireDefault(require("../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function isAnonymous(routes, req) {
  if (!!routes && routes.length > 0) {
    // Return true if any route is anonymous
    return !!(0, _find2.default)(routes, function (route) {
      var _route$handle, _route$handle2, _route$handle3;
      return (
        // Run isAnonymous function, or use boolean value
        (0, _isFunction.default)((_route$handle = route.handle) === null || _route$handle === void 0 ? void 0 : _route$handle.isAnonymous) ? (_route$handle2 = route.handle) === null || _route$handle2 === void 0 ? void 0 : _route$handle2.isAnonymous(route, req) : ((_route$handle3 = route.handle) === null || _route$handle3 === void 0 ? void 0 : _route$handle3.isAnonymous) === true
      );
    });
  }
  return false;
}
function getRouteCspOptions(routes) {
  if (!!routes && routes.length > 0) {
    var _find;
    return ((_find = (0, _find2.default)(routes, function (route) {
      var _route$handle4;
      return route === null || route === void 0 || (_route$handle4 = route.handle) === null || _route$handle4 === void 0 ? void 0 : _route$handle4.csp;
    })) === null || _find === void 0 || (_find = _find.handle) === null || _find === void 0 ? void 0 : _find.csp) || {};
  }
  return {};
}
function isForcedSignOut(routes) {
  if (!!routes && routes.length > 0) {
    // Check if any route is forceSignOut
    return !!(0, _find2.default)(routes, function (route) {
      var _route$handle5;
      return ((_route$handle5 = route.handle) === null || _route$handle5 === void 0 ? void 0 : _route$handle5.forceSignOut) === true;
    });
  }
  return false;
}
function isFloorplansDisabled(routes) {
  if (!!routes && routes.length > 0) {
    // Check if any route is disableFloorplans
    return !!(0, _find2.default)(routes, function (route) {
      var _route$handle6;
      return ((_route$handle6 = route.handle) === null || _route$handle6 === void 0 ? void 0 : _route$handle6.disableFloorplans) === true;
    });
  }
  return false;
}
function getResponseHeaders(routes) {
  if (!!routes && routes.length > 0) {
    // Get array of response header objects
    var responseHeadersArray = routes.map(function (route) {
      var _route$handle7, _route$handle8;
      return (0, _isFunction.default)((_route$handle7 = route.handle) === null || _route$handle7 === void 0 ? void 0 : _route$handle7.getResponseHeaders) && ((_route$handle8 = route.handle) === null || _route$handle8 === void 0 ? void 0 : _route$handle8.getResponseHeaders());
    });

    // Combine array of response headers into one object and add the sameorigin X-Frame-Options
    var responseHeaderObject = _objectSpread({
      'X-Frame-Options': 'sameorigin'
    }, responseHeadersArray.reduce(function (headers, current) {
      return _objectSpread(_objectSpread({}, headers), current);
    }));
    return responseHeaderObject;
  }
  return {};
}
function getRedirectLocation(routes) {
  var defaultRedirectLocation = {
    redirectPath: '',
    redirectSearch: ''
  };
  if (!!routes && routes.length > 0) {
    // Find first route that has a redirect
    var redirectRoute = (0, _find2.default)(routes, function (route) {
      var _route$handle9;
      return !!((_route$handle9 = route.handle) !== null && _route$handle9 !== void 0 && _route$handle9.redirectLocation);
    });

    // If no redirect exists, return defaults
    if (!redirectRoute) {
      return defaultRedirectLocation;
    }

    // Accept both string or object for redirectLocation flag
    var redirectLocation = redirectRoute.handle.redirectLocation;
    var redirectPath;
    var redirectSearch = '';
    if (typeof redirectLocation === 'string') {
      redirectPath = redirectLocation;
    } else {
      redirectPath = redirectLocation.pathName;
      redirectSearch = redirectLocation.search;
    }
    return {
      redirectPath: redirectPath,
      redirectSearch: redirectSearch
    };
  }
  return defaultRedirectLocation;
}
function getStatus(routes) {
  var statusCode;
  if (!!routes && routes.length > 0) {
    var _statusRoute$handle;
    // Find first route that has a status
    var statusRoute = (0, _find2.default)(routes, function (route) {
      var _route$handle0;
      return !!((_route$handle0 = route.handle) !== null && _route$handle0 !== void 0 && _route$handle0.status);
    });

    // If no status exists, return defaults
    statusCode = statusRoute === null || statusRoute === void 0 || (_statusRoute$handle = statusRoute.handle) === null || _statusRoute$handle === void 0 ? void 0 : _statusRoute$handle.status;
  }
  return statusCode;
}
function getIsAuthorizedArray(routes) {
  var isAuthorizedArray = [];
  routes && routes.forEach(function (route) {
    var _route$handle1;
    if ((_route$handle1 = route.handle) !== null && _route$handle1 !== void 0 && _route$handle1.isAuthorized) {
      var _route$handle10;
      isAuthorizedArray.push((_route$handle10 = route.handle) === null || _route$handle10 === void 0 ? void 0 : _route$handle10.isAuthorized);
    }
  });
  return isAuthorizedArray;
}
function getForbiddenUrl(baseUrl, routes, setBaseUrl) {
  var matchingRoutes = (0, _reactRouter.matchRoutes)(routes, "".concat(setBaseUrl ? baseUrl : _config.default.nui.baseUrl, "/forbidden"), setBaseUrl ? baseUrl : _config.default.nui.baseUrl);
  var forbiddenRoute = (0, _find2.default)(matchingRoutes, function (route) {
    var _route$handle11;
    return ((_route$handle11 = route.handle) === null || _route$handle11 === void 0 ? void 0 : _route$handle11.status) === 403;
  });
  if (!forbiddenRoute) {
    return "".concat(baseUrl, "/forbidden");
  }
  return forbiddenRoute.pathname;
}
function getServerErrorUrl(baseUrl, routes, setBaseUrl) {
  var matchingRoutes = (0, _reactRouter.matchRoutes)(routes, "".concat(setBaseUrl ? baseUrl : _config.default.nui.baseUrl, "/serverError"), setBaseUrl ? baseUrl : _config.default.nui.baseUrl);
  var serverErrorRoute = (0, _find2.default)(matchingRoutes, function (route) {
    var _route$handle12;
    return ((_route$handle12 = route.handle) === null || _route$handle12 === void 0 ? void 0 : _route$handle12.status) === 500;
  });
  if (!serverErrorRoute) {
    return "".concat(baseUrl, "/serverError");
  }
  return serverErrorRoute.pathname;
}